import React, { useEffect, useState } from 'react';
import { BookOpen, ExternalLink, X } from 'lucide-react';
import { useAuth } from '../../context/authContext';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';
import { PORTAL_DOCS_URL } from '../../config/portal.config';
import { Button } from '../ui/button';

const getDismissKey = (userId) => `yvr-portal-welcome-dismissed-${userId}`;

const WelcomeBanner = () => {
    const { user } = useAuth();
    const { advancedFeaturesEnabled } = useFeatureAccess();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!user?.id) return;
        setVisible(localStorage.getItem(getDismissKey(user.id)) !== 'true');
    }, [user?.id]);

    const dismiss = () => {
        if (user?.id) {
            localStorage.setItem(getDismissKey(user.id), 'true');
        }
        setVisible(false);
    };

    if (!visible) return null;

    const firstName = user?.name?.trim().split(/\s+/).filter(Boolean)[0];

    return (
        <div
            role="status"
            className="mb-8 rounded-lg border border-yavrio-green/20 bg-gradient-to-r from-yavrio-green/5 via-white to-white px-5 py-4 shadow-sm"
        >
            <div className="flex items-start gap-4">
                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-yavrio-green/10 border border-yavrio-green/20">
                    <BookOpen className="h-5 w-5 text-yavrio-green" />
                </span>

                <div className="min-w-0 flex-1">
                    {/* <p className="text-base font-semibold text-[#2E2E2E] m-0">
                        {firstName ? `Welcome, ${firstName}` : 'Welcome to the new portal'}
                    </p> */}
                    {/* <p className="text-base font-semibold text-[#2E2E2E] m-0">
                        New look, same trusted process.
                    </p> */}
                    <p className="text-sm text-slate-600 mt-1 mb-0 leading-relaxed">
                        Hi! We've updated the look & feel of our portal, but everything you need to review and authorise payments is still right where you expect it.
                    </p>
                    {/* {advancedFeaturesEnabled && (
                        <p className="text-sm text-slate-600 mt-0 mb-2 leading-relaxed">
                            Additional features coming soon for your organisation.
                        </p>
                    )} */}
                    {/* <Button
                        asChild
                        variant="outline"
                        size="sm"
                        className="h-8 border-yavrio-green/30 text-yavrio-green hover:bg-yavrio-green/5 hover:text-yavrio-green"
                    >
                        <a
                            href={PORTAL_DOCS_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            View user guides
                            <ExternalLink className="ml-1.5 h-3.5 w-3.5" />
                        </a>
                    </Button> */}
                </div>

                <button
                    type="button"
                    onClick={dismiss}
                    className="shrink-0 rounded-md p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
                    aria-label="Dismiss welcome message"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
};

export default WelcomeBanner;
